import { CSVField } from 'hooks/useExportCSV'
import { useMemo } from 'react'
import { formatDate } from 'utils'

export function useCohortCSVField() {
  return useMemo<CSVField[]>(
    () => [
      {
        label: 'User Tag Name',
        value: 'name',
      },
      {
        label: 'Creation Date',
        value: ({ createdAt }) => formatDate(createdAt),
      },
      {
        label: 'Last Edited',
        value: ({ updatedAt }) => formatDate(updatedAt),
      },
    ],
    [],
  )
}
